import axiosInstance from "./axios";

export class CicloService {
    getCiclos() {
        return axiosInstance
            .get("/ciclo")
            .then((res) => res.data)
    }

    addCiclo(dto) {
        return axiosInstance
            .post("/ciclo", dto)
            .then((res) => res.data)
    }

    updateCiclo(dto) {
        return axiosInstance
            .put(`/ciclo/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteCiclo(id) {
        return axiosInstance
            .delete(`/ciclo/${id}`)
            .then((res) => res.data)
    }
}
